module.exports = __webpack_public_path__ + "img/behaviour-2-mobile.302e99d2.gif";